module.exports = __webpack_public_path__ + "img/documents-sarah_Laudos.8989e42e.svg";